export default  {
    TOGGLE_CHAT(state) {
      state.isOpen = !state.isOpen;
    },
    SET_OPEN(state, value) {
      state.isOpen = value;
    },
    ADD_MESSAGE(state, message) {
      state.messages.push(message);
    },
    SET_LOADING(state, value) {
      state.isLoading = value;
    }
  }